
const state = {
    gradeRankOptions: [
        {
            label: "药店",
            value: 1,
        },
        {
            label: "基层医卫",
            value: 2,
        },
        {
            label: "连锁公司",
            value: 3,
        },
        {
            label: "商业公司",
            value: 4,
        },
        {
            label: "医院",
            value: 5,
        },
        {
            label: "专业公卫",
            value: 6,
        },
        {
            label: "器械批发",
            value: 7,
        },
    ],
}

const mutations = {
    SET_GRADE_RANK_OPTIONS(state, options) {
        state.gradeRankOptions = options
    }
}

const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

